/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

function plural(val: number): number {
const n = val, i = Math.floor(Math.abs(val));

if (i === 0 || n === 1)
    return 1;
return 5;
}

export default ["pcm",[["AM","PM"],u,["Fọ mọ́nin","Fọ ívnin"]],u,[["S","M","T","W","T","F","S"],["Sọ́n","Mọ́n","Tiú","Wẹ́n","Tọ́z","Fraí","Sát"],["Sọ́ndè","Mọ́ndè","Tiúzdè","Wẹ́nẹ́zdè","Tọ́zdè","Fraídè","Sátọdè"],["Sọ́n","Mọ́n","Tiú","Wẹ́n","Tọ́z","Fraí","Sát"]],u,[["J","F","M","A","M","J","J","A","S","O","N","D"],["Jén","Fẹ́b","Mach","Épr","Mee","Jun","Jul","Ọgọ","Sẹp","Ọkt","Nọv","Dis"],["Jénúári","Fẹ́búári","Mach","Éprel","Mee","Jun","Julai","Ọgọst","Sẹptẹ́mba","Ọktóba","Nọvẹ́mba","Disẹ́mba"]],[["J","F","M","A","M","J","J","A","S","O","N","D"],["Jén","Fẹ́b","Mach","Épr","Mee","Jun","Jul","Ọ́gọ","Sẹp","Ọkt","Nọv","Dis"],["Jénúári","Fẹ́búári","Mach","Éprel","Mee","Jun","Julai","Ọgọst","Sẹptẹ́mba","Ọktóba","Nọvẹ́mba","Disẹ́mba"]],[["BK","KIY"],u,["Bifọ́ Kraist","Kraist Im Yiẹ"]],1,[6,0],["dd/MM/y","d MMM y","d MMMM y","EEEE, d MMMM y"],["HH:mm","HH:mm:ss","H:mm:ss z","HH:mm:ss zzzz"],["{1} {0}",u,"{1} 'fọ' {0}",u],[".",",",";","%","+","-","E","×","‰","∞","NaN",":"],["#,##0.###","#,##0%","¤#,##0.00","#E0"],"NGN","₦","Naijíriá Naíra",{"BYN":[u,"p."],"CAD":["KA$","$"],"JPY":["JP¥","¥"],"NGN":["₦"],"PHP":[u,"₱"],"USD":["US$","$"]},"ltr", plural];
